import { classnames } from '@/helpers';
import { customTwMerge } from '@/helpers/theme';
import { _t } from '@/locale';
import { ReactNode } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

export type CategoryHeaderProps = {
  title: string | ReactNode;
  titleClassName?: string;
  titleAs?: 'h2' | 'h3' | 'h4';
  link?: { to: LinkProps['to']; onClick?: () => void };
  className?: string;
};

const CategoryHeader = ({ title, titleClassName, titleAs, link, className }: CategoryHeaderProps) => {
  const TitleTag = titleAs || 'span';
  return (
    <div className={twMerge(classnames('gap-xs relative flex items-baseline', className))}>
      <TitleTag
        className={customTwMerge(
          classnames(
            'text-h-m text-fg_primary overflow-hidden text-ellipsis whitespace-nowrap font-semibold',
            titleClassName,
          ),
        )}>
        {title}
      </TitleTag>

      {link && (
        <Link
          className="text-fg_link text-m hover:text-fg_link_hover active:text-fg_link_pressed gap-2xs inline-flex flex-shrink-0 items-center font-bold after:absolute after:inset-0 after:content-['']"
          to={link.to}
          {...(link.onClick && { onClick: link.onClick })}>
          {_t('showAll')}
          <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.359702 0.198683C0.783905 -0.104334 1.4152 -0.0552412 1.76874 0.308331L6.76824 5.45092C7.07725 5.76877 7.07725 6.23123 6.76824 6.54908L1.76874 11.6917C1.4152 12.0552 0.783905 12.1043 0.359702 11.8013C-0.0644449 11.4983 -0.121717 10.9571 0.231785 10.5935L4.69716 6L0.231785 1.40649C-0.121717 1.04287 -0.064445 0.501735 0.359702 0.198683Z"
              fill="currentColor"
            />
          </svg>
        </Link>
      )}
    </div>
  );
};

export default CategoryHeader;
